import Cookies from 'js-cookie';
import { closeNotice } from '@/libs/notice';

const development = import.meta.env.MODE === 'development';
const TokenKey = 'Admin-Token';

export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token: string) {
    // console.log('process.env', development);
    // console.log('setToken token', token);
    if (development && window.location.protocol === 'https:') {
        return Cookies.set(TokenKey, token, { SameSite: 'None', Secure: true });
    }
    if (development) {
        return Cookies.set(TokenKey, token, { SameSite: 'Lax' });
    }
    return Cookies.set(TokenKey, token);
}

export function removeToken() {
    closeNotice();
    if (development && window.location.protocol === 'https:') {
        return Cookies.remove(TokenKey, { SameSite: 'None', Secure: true });
    }
    if (development) {
        return Cookies.remove(TokenKey, { SameSite: 'Lax' });
    }
    return Cookies.remove(TokenKey);
}






//新增 缓存账户
const AccountKey = 'account';



export function setStorageAccount(account: any) {
    return  localStorage.setItem(AccountKey,account)
}

export function removeStorageAccount() {
    return localStorage.removeItem(AccountKey);
}
